export default "__VITE_ASSET__CBYPlj54__"